export const defaultMessage = [

    "Hello! We've met recently in Astana and it was great catching up with you. Please feel free to reach out as I'm always looking for any collaboration. Below you can find all the information about what I do.",
]